import { render, staticRenderFns } from "./bao-cao-xuat.vue?vue&type=template&id=6e8d6663&scoped=true&"
import script from "./bao-cao-xuat.vue?vue&type=script&lang=js&"
export * from "./bao-cao-xuat.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-xuat.vue?vue&type=style&index=0&id=6e8d6663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/mikobi_house/admin-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d6663",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../DATA/projects/mikobi_house/admin-ctv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VContainer,VDataTable,VFlex,VLayout,VSelect})
